import React from 'react'
import { Link } from 'react-router-dom'
import Login from './Login'
import Signup from './Signup'
import Welcome from './Welcome'

const Home = () => {
  let content = <Welcome />
  if (window.location.pathname === '/login') {
    content = <Login />
  } else if (window.location.pathname === '/signup') {
    content = <Signup />
  }

  return (
    <div className='home font125'>
      <div className='home-bg-image' />
      <Link to='/'>
        <h1 className='text-shadow roboto fw700 white ls25 font375'>
          Check2Check
        </h1>
      </Link>
      <div
        className='bg-middle-blue'
        style={{ height: '2px', width: '7em', margin: '1em auto 1.75em' }}
        aria-hidden='true'
      />
      {content}
    </div>
  )
}

export default Home
